export default "__VITE_ASSET__1bfdf4c4__"